module.exports = __webpack_public_path__ + "img/DK27192572.27d9e9ab.svg";